// Generated by BUCKLESCRIPT VERSION 5.0.4, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var React = require("react");

var hr = Css.style(/* :: */[
      Css.borderBottom(Css.px(0), /* none */-922086728, Css.black),
      /* :: */[
        Css.borderTop(Css.px(1), /* solid */12956715, Css.hex("ccc")),
        /* :: */[
          Css.margin2(Css.px(24), /* auto */-1065951377),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[/* hr */hr];

function Divider(Props) {
  return React.createElement("hr", {
              className: hr
            });
}

var make = Divider;

var $$default = Divider;

exports.Styles = Styles;
exports.make = make;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
/* hr Not a pure module */
